export default __webpack_public_path__ + "media/58b7ae2b27b0ad712fc7a2219c6875e17ed218588a4ee783cc92fb034681b20c.svg";